//@flow
import * as React from 'react';
import type {children, id} from "../../../../services/flowTypes/appFlowTypes";
import type {addClasses} from "../../../../services/flowTypes/uiKitFlowTypes";
import {baseClass} from "../../../../pages/UiKit/newUiKit/utilities/baseClass";
import './SecText.css';

type Props = {
  id?: id,
  addClasses?: addClasses,
  children: children
};

const SecText = (props: Props) => {
  return (
    <div id={props.id} className={baseClass("SecText", props.addClasses)}>{props.children}</div>
  );
};

export default SecText;